<!--Footer Starts-->
<footer class="footer">
  <img src="assets/img/logoAfin.png" style="display: block; margin:auto; width:15rem;">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink" href="https://afingana.com/" target="_blank" style="color:#4bbdb1;"> AFIN GANA SA DE CV SOFOM ENR</a>
    <span class="d-none d-sm-inline-block">, Todos los derechos reservados.</span>
  </p>
  <p style="font-size: 0.7rem;">444 825 3398 y 444 825 2196 | contacto@afingana.com</p>

</footer>
<!--Footer Ends-->
